import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { CommentOptsStoreModel } from "./CommentOptsStore";
import { SearchForAddonStoreModel } from "./SearchForAddonStore";
import { CmsUkCouponStore } from "./CmsUkCouponStore";
import { CheckoutStoreModel } from "./CheckoutStore";
import { LoginStoreModel} from "./loginStore";
import { CartStoreModel } from "./CartStore";
import { DpStoreModel } from "./DpStore";
import { CountryStoreModel } from "./CountryStore";

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model("RootStore").props({
  commentOpstsStore: types.optional(CommentOptsStoreModel, {}),
  searchForAddonStore: types.optional(SearchForAddonStoreModel, {}),
  cmsUkCouponStore: types.optional(CmsUkCouponStore, {}),
  checkoutStore: types.optional(CheckoutStoreModel, {}),
  loginStore: types.optional(LoginStoreModel, {}),
  cartStore: types.optional(CartStoreModel, {}),
  dpStore: types.optional(DpStoreModel, {}),
  countryStore: types.optional(CountryStoreModel, {}),
});

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}
/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
